<template>
    <div class="grid-content">
        <el-card :body-style="{ padding: '0px' }"  shadow="never" style="border: none;">
        <div style="padding: 10px 0;" v-show="pageType!='config'">
            <span>{{material.show_name}}</span>
        </div>
        <el-popover
        placement="top"
        width="350"
        trigger="hover"
        v-model="show"
        :show="handleShow"
        :hide="handleHide">
        <div>
            <p>宽：{{material.width}}，高：{{material.height}}</p>
        <img v-if="material.material_type == 1 && show" :src="material.material_url" style="width: 100%;"/>
        <video
            style="width: 100%;"
            controls="controls"
            autoplay
            muted
            v-if="material.material_type == 2 && show"
            >
            <source :src="material.material_url" type="video/mp4" />
        </video>
        </div>
        <div slot="reference">
            <div style="height: 100px;display: flex;flex-direction: column;justify-content: center;border: 1px solid #f1f1f1;">
                <img v-if="material.material_type == 1" :src="material.material_url" style="height: 100px;object-fit: contain;"/>
                <video
                    style="height: 100px;object-fit: contain;"
                    v-if="material.material_type == 2"
                    >
                    <source :src="material.material_url" type="video/mp4" />
                </video>
            </div>
            
        </div>
        
        </el-popover>
        <div class="material-name-text" style="padding: 10px 0;">
            <el-tooltip class="item" effect="dark" :content="material.material_name" placement="top-start">
                <span style="display: inline-block;width: 100%;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{material.material_name}}</span>
            </el-tooltip>
        </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "cardItem",
        props:{
            material:Object,
            pageType:{
                type:String,
                default:'',
            },
        },
        data(){
            return {
                show: false
            }
        },
        methods:{
            handleShow() {
                this.show = true
            },
            handleHide() {
                this.show = false
            }
        }
    }
</script>

<style scoped>

</style>
